<template src="./Default.html"></template>

<script>
import AppHeader from '@/components/AppHeader';
import AppFooter from '@/components/AppFooter';
import CartSidebar from '@/components/CartSidebar';
import BottomNavigation from '@/components/BottomNavigation';
import MenuModal from '@/components/MenuModal';
import ProductsActionModal from '@/components/ProductsActionModal';
import ResetPasswordModal from '@/components/ResetPasswordModal';
import WelcomeModal from '@/components/WelcomeModal';
import LoginModal from "@/components/LoginModal";
import Notification from "@/components/Notification";
import TopBar from "@/components/TopBar";
import AddressModal from '@/components/AddressModal';
import {SfIcon} from "@storefront-ui/vue"
import icons from "@/utils/icons";
import PasswordExpiredModal from "@/components/PasswordExpiredModal.vue";

export default {
  components: {
    SfIcon,
    AddressModal,
    ProductsActionModal,
    ResetPasswordModal,
    AppFooter,
    AppHeader,
    CartSidebar,
    LoginModal,
    Notification,
    TopBar,
    MenuModal,
    WelcomeModal,
    BottomNavigation,
    PasswordExpiredModal
  },
  data() {
    return {
      scTimer: 0,
      scY: 0,
      icons: icons
    }
  },

  mounted() {
    window.addEventListener('scroll', this.handleScroll);

  },
  methods: {
    handleScroll: function () {
      if (this.scTimer) return;
      this.scTimer = setTimeout(() => {
        this.scY = window.scrollY;
        clearTimeout(this.scTimer);
        this.scTimer = 0;
      }, 100);
    },
    toTop: function () {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
  },
};
</script>

<style lang="scss">
#main {
  transition: 0.3s ease all;
}

.activeMenu {
  overflow: hidden;

  #AFMenu {
    transform: translateX(0);
  }

  #main {
    transform: translateX(300px);
  }
}

</style>

